import ListaPagoAbono from '../componentes/ListaPagoAbono.vue'


const routes = [
     ...route('/lista-pagos', ListaPagoAbono, {
       Auth: true,
       //req_admin: true
    }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes